import React from "react";

const AccessDenied = () => {
  return (
    <>
      <h1>Access Denied</h1>
    </>
  );
};

export default AccessDenied;
